import type { AnalyticsObject, AnalyticsProperties } from '../types'

export type CountryParams = {
  iso: string
}

export interface CountryProperties extends AnalyticsProperties {
  isoCode: string
}

export class Country implements AnalyticsObject {
  name: string
  properties: CountryProperties
  constructor(properties: CountryProperties) {
    this.name = 'Country'
    this.properties = properties
  }

  static getInstance(country: CountryParams) {
    return new Country({ isoCode: country.iso })
  }
}
